import { CookiebarView } from '@shared/Frontend/libraries/cookiebar/cookiebar.template'
import { cookies, no, requiredCookies, yes } from '@shared/Frontend/utils/hoppingerCookies'
import { translate } from '@shared/Frontend/utils/translate'
import React from 'react'
import { FormControls } from '../../../forms'
import { Clickable } from '../../../utils/clickable'

export const Cookiebar: CookiebarView['Cookiebar'] = ({
  showOptions,
  toggleOptions,
  onAcceptAll,
  onDeclineAll,
  onApplySettings,
  onSetSingle,
  selectedCookieValues,
}) => (
  <section
    id="cookiebar"
    role="alert"
    aria-labelledby="a11y-cookiebar-title"
    aria-describedby="a11y-cookiebar-intro"
    aria-live="polite"
    className="cookiebar"
  >
    <div className="cookiebar__inner ls-container ls-gutter">
      <header className="cookiebar__header">
        <h3 id="a11y-cookiebar-title" className="cookiebar__title title--sm">
          {translate('cookies:cookiebarTitle', {}, 'Please accept the cookies')}
        </h3>
        <p
          className="cookiebar__intro text--sm text--styled"
          dangerouslySetInnerHTML={{
            __html: showOptions
              ? translate(
                  'cookies:cookiebarIntroSettings',
                  {},
                  'Enable or disable certain type of cookies to personalise your experience on our website.'
                )
              : translate(
                  'cookies:cookiebarIntro',
                  {},
                  "By clicking 'accept cookies' you agree to the use of cookies to process your personal data."
                ),
          }}
        />
      </header>

      <footer className="cookiebar__footer ls-clickables">
        <div className="ls-clickable">
          <Clickable
            elementKind="button"
            styleKind="button"
            label={translate('cookies:cookiebarAcceptCookies', {}, 'Accept all')}
            onClick={onAcceptAll}
            className="cookiebar__clickable button button--small"
            hasBlob={true}
            icon={'icon-chevron-right'}
          />
        </div>
        <div className="ls-clickable">
          <Clickable
            elementKind="button"
            styleKind="link"
            label={translate('cookies:cookiebarDeclineCookies', {}, 'Decline all')}
            onClick={onDeclineAll}
            className="cookiebar__clickable link link--filled link--small"
            hasBlob={true}
            icon={'icon-chevron-right'}
          />
        </div>

        {/* Expand button */}
        <div className="ls-clickable">
          <Clickable
            elementKind="button"
            styleKind="link"
            label={translate('cookies:cookiebarShowOptions', {}, 'Show more')}
            onClick={toggleOptions}
            aria-controls="a11y-cookiebar-toggle"
            aria-expanded={showOptions}
            className="cookiebar__clickable link link--hollow link--small"
            hasBlob={true}
            icon={showOptions ? 'icon-chevron-up' : 'icon-chevron-down'}
          />
        </div>
      </footer>

      {showOptions && (
        <form
          id="a11y-cookiebar-toggle"
          className="cookiebar__form"
          hidden={!showOptions}
          onSubmit={(e) => {
            e.preventDefault()
            onApplySettings()
          }}
        >
          <fieldset className="cookiebar__fieldset text--sm">
            <legend className="cookiebar__legend sr-text">
              {translate('cookies:cookiebarOptionsA11y', {}, 'Choose your preferences')}
            </legend>

            {cookies.map((cookie) => {
              return (
                <FormControls.FormCheckInGroup
                  controlId="cookie"
                  required={requiredCookies.includes(cookie)}
                  disabled={requiredCookies.includes(cookie)}
                  invalid={false}
                  items={[
                    {
                      controlId: cookie,
                      label: (
                        <>
                          {translate(
                            cookie === 'functional-cookies'
                              ? 'cookies:cookiebarFunctional'
                              : cookie === 'analytical-cookies'
                              ? 'cookies:cookiebarAnalytical'
                              : cookie === 'tracking-cookies'
                              ? 'cookies:cookiebarTracking'
                              : 'cookies:cookiebarVideos',
                            {},
                            cookie
                          )}
                          {'. '}
                          {translate(
                            cookie === 'functional-cookies'
                              ? 'cookies:cookiebarFunctionalCookies'
                              : cookie === 'analytical-cookies'
                              ? 'cookies:cookiebarAnalyticalCookies'
                              : cookie === 'tracking-cookies'
                              ? 'cookies:cookiebarTrackingCookies'
                              : 'cookies:cookiebarVideosCookies'
                          )}
                        </>
                      ),
                      checked: selectedCookieValues[cookie] === yes,
                      onChange: (newValue) => onSetSingle(cookie, newValue ? yes : no),
                    },
                  ]}
                />
              )
            })}
          </fieldset>

          <footer className="cookiebar__footer ls-clickables">
            <div className="ls-clickable">
              <Clickable
                type="submit"
                elementKind="button"
                styleKind="button"
                label={translate('cookies:cookiebarChangeSettings', {}, 'Update')}
                className="cookiebar__clickable button button--small"
                hasBlob={true}
                icon={'icon-chevron-right'}
              />
            </div>
          </footer>
        </form>
      )}
    </div>
  </section>
)
